import { render, staticRenderFns } from "./EModalAnexarPlanejamentoSemestral.vue?vue&type=template&id=0315ae38"
import script from "./EModalAnexarPlanejamentoSemestral.vue?vue&type=script&lang=js"
export * from "./EModalAnexarPlanejamentoSemestral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports